"use client";
import React, { useState } from "react";

export const ReadMore = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [visible, setVisible] = useState(true);

  return (
    <div className="read-more">
      <h1
        style={{
          textTransform: "uppercase",
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        What is uniwerse?
      </h1>
      <div className="read-more-content">
        <div className="leading-relaxed">
          <p>
            It is a unique web space/werse. It`s a immersive digital experience
            platform. A unique three-dimensional environment combines and
            integrates a load of new innovative web technologies and various
            creative high-end visual content.
          </p>
          {!visible && (
            <>
              <p>
                We create unique web spaces, web uniwerses, showing off the
                abilities of innovative spatial web programming,
                state-of-the-art 3D graphics and ingenious visual information
                sharing, resulting into a immersive exploration and unique
                digital experience.
              </p>
              <p>
                <p style={{ fontWeight: "bold" }}>Uniwerse 3Dweb Benefits:</p>
                - All-in-one immersive digital experience content
                <br />
                - Full direct online accessibility
                <br />
                - Complex visual information
                <br />
                - Interesting interactivity
                <br />
                - Simple functionality and user interface
                <br />
                - Connectivity accross social networks
                <br />
                - Integration of communication channels
                <br />
                - Experiential sales tool
                <br />
                - Any kind of product integration
                <br />
                - Attractive playful 3D environment
                <br />
              </p>
              <p>
                <p style={{ fontWeight: "bold" }}>
                  Visual content production and integration:
                </p>
                a) interactive 3D model(modeled or scanned)
                <br />
                b) explanatory motion graphics
                <br />
                c) cinematic animations and simulations
                <br />
                d) interactive technical specification
                <br />
                e) interactive project/product information
                <br />
                f) photos and videos
                <br />
                g) configuration options(product configurator)
                <br />
                h) virtual interior/exterior tours
                <br />
                i) full support and maintanance service
                <br />
                <br />
                Your project will be customized and personalized to your needs
                and wishes with an option to embed to your existing
                website.(confidential VIP access as a option).
                <br />
              </p>
            </>
          )}
        </div>
        <p
          style={{
            fontSize: "14px",
            color: "#15D5F7",
            cursor: "pointer",
            marginRight: "10px",
            marginLeft: "10px",
          }}
          onClick={() => setVisible((prev) => !prev)}
        >
          {visible ? "Read More" : "Read Less"}
        </p>
      </div>
      {/* </div> */}
    </div>
  );
};
